import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getAllowedOutputs } from './strata_compatibility_checks';

Blockly.Blocks['strata_update_dashboard'] = {
    init: function () {
        this.appendDummyInput()
            .appendField("Update dashboard");
        
        // this.appendDummyInput()
        //     .appendField('Include Exposure score:')
        //     .appendField(new Blockly.FieldCheckbox(true), 'is_exposure_included');

        this.appendDummyInput()
            .appendField('Include Vulnerability score:')
            .appendField(new Blockly.FieldCheckbox(false), 'is_vulnerability_included');

        this.setPreviousStatement(true, 'strata_update_dashboard');
        this.setNextStatement(true, getAllowedOutputs('strata_calculate_stress'));
        this.setColour('#53565a');
        this.setStyle("dashboards")
        this.setTooltip("");
        this.setHelpUrl("");
    },

}